// src/store/useLiveClassStore.js

import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useLiveSession = create(
  persist(
    (set, get) => ({
      liveClassDocs: null,
      liveClassDoc: null,
      liveClassAction: {
        liveClassId: "",
        action: "", // e.g., "edit", "delete"
      },
      _hasHydrated: false,

      setLiveClassAction: (liveClassAction) => {
        set({ liveClassAction });
      },

      setLiveClassDoc: (liveClassDoc) => {
        set({ liveClassDoc });
      },

      setLiveClassDocs: (liveClassDocs) => {
        set({ liveClassDocs });
      },

      getLiveClassDocs: () => {
        return get().liveClassDocs;
      },

      setHasHydrated: (value) => set({ _hasHydrated: value }),
    }),
    {
      name: "liveClass-storage",
      getStorage: () => localStorage,

      partialize: (state) => ({
        _hasHydrated: state._hasHydrated,
      }),

      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    }
  )
);
